import { render, staticRenderFns } from "./TodoPage.vue?vue&type=template&id=6e483369&"
import script from "./TodoPage.vue?vue&type=script&lang=js&"
export * from "./TodoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports